import { Routes, Route, Navigate } from "react-router-dom";

// Material Dashboard 2 React routes
import routes from "./routes";

export default function Integration() {
  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.items && route.items.length) {
        return getRoutes(route.items);
      }

      if (route.route) {
        return (
          <Route
            exact
            path={route.route}
            element={route.component}
            key={route.key}
          />
        );
      }

      return null;
    });

  return (
    <div>
      <Routes>{getRoutes(routes)}</Routes>
    </div>
  );
}
